import { Transaction } from '@iota/iota-sdk/transactions';
import type { WalletAccount } from '@wallet-standard/core';
import BigNumber from 'bignumber.js';

import { IOTA_DEFAULT_DIVIDER } from 'modules/common/const';

interface IPrepareNativeCoinsParams {
  walletAccount: WalletAccount;
  amount: BigNumber;
}

export function prepareNativeCoinsTransaction({
  amount,
}: IPrepareNativeCoinsParams) {
  const transaction = new Transaction();

  const requiredAmount = BigInt(
    amount.multipliedBy(IOTA_DEFAULT_DIVIDER).toString(10),
  );

  const [preparedCoins] = transaction.splitCoins(transaction.gas, [
    requiredAmount,
  ]);

  return { transaction, preparedCoins };
}
